import React from "react";
import ModalBasic from "../../pages/component/ModalBasic.js";
import moment from "moment";
import { Companyname } from "../../utils/AppSetting.js";
import { printReqFunction } from "../print/printTemplate.js";

export default function ProductionRMSlipModel(props) {
  return (
    <>
      <ModalBasic
        id="send-for-approve-modal"
        modalOpen={props.setRMSlipModel}
        setModalOpen={props.setModalOpen}
        noCloseIcon={true}
        className="!max-w-[860px] w-full !p-0 !overflow-hidden"
      >
        {/* ── ACTION TOOLBAR (Cancel + Print) ── */}
        <div className="print:hidden flex items-center justify-between px-5 py-3 bg-gray-100 border-b border-gray-300 sticky top-0 z-10">
          <span className="text-[12px] uppercase tracking-widest text-gray-500 font-semibold">
            Print Preview — A4
          </span>
          <div className="flex items-center gap-2">
            {/* Cancel */}
            <button
              className="flex items-center gap-1.5 bg-white hover:bg-gray-50 text-gray-700 text-[13px] font-medium px-4 py-1.5 rounded border border-gray-300 shadow-sm transition-colors duration-150"
              onClick={() => props.setModalOpen(false)}
            >
              <svg className="w-2 h-2" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <path d="M1 1l12 12M13 1L1 13" />
              </svg>
              Cancel
            </button>
            {/* Print */}
            <button
              className="flex items-center gap-1.5 bg-blue hover:bg-blue/70 text-white text-[13px] font-medium px-4 py-1.5 rounded shadow-sm transition-colors duration-150"
              onClick={() => printReqFunction()}
            >
              <svg className="w-3 h-3" viewBox="0 0 16 16" fill="currentColor">
                <path d="M4 2h8v3H4V2zM2 6h12a1 1 0 011 1v5H11v-2H5v2H1V7a1 1 0 011-1zm3 7h6v2H5v-2z" />
              </svg>
              Print
            </button>
          </div>
        </div>

        <div
          className="print:bg-white print:p-0 bg-gray-300 overflow-y-auto flex flex-col items-center py-6"
          style={{ maxHeight: "calc(100vh - 130px)" }}
          id="printableArea"
        >
          <div
            className="bg-white shadow-xl w-[794px] min-h-[1123px] px-[56px] py-[48px] font-sans box-border"
          >
            <div className="flex justify-between items-end pb-2.5 mb-4 border-b-2 border-gray-800">
              <div>
                <h1 className="text-[18px] font-bold text-gray-900 uppercase tracking-wide">
                  {Companyname}
                </h1>
                <p className="text-[14px] font-semibold text-gray-800 mt-0.5">
                  Production Requisition Slip
                </p>
              </div>

            </div>

            <div className="flex items-center gap-3 bg-gray-50 border border-gray-200 rounded px-4 py-2 mb-4">
              <div className="flex-1">
                <p className="text-[10px] uppercase tracking-widest text-gray-500 mb-0.5">From</p>
                <p className="text-[12px] font-bold text-gray-600">Production DEPT.</p>
              </div>
              <span className="text-gray-700 text-[16px]">→</span>
              <div className="flex-1 text-right">
                <p className="text-[10px] uppercase tracking-widest text-gray-500 mb-0.5">To</p>
                <p className="text-[12px] font-bold text-gray-600">Store DEPT.</p>
              </div>
            </div>

            <div className="border border-gray-200 rounded overflow-hidden mb-4">
              <div className="flex items-baseline gap-3 bg-gray-50 border-b border-gray-200 px-3 py-2">
                <span className="text-[10px] uppercase tracking-widest text-gray-500 whitespace-nowrap">
                  Product Name :
                </span>
                <span className="text-[14px] font-bold text-gray-700">
                  {props.productionRequisition.productName}
                </span>
              </div>

              <div className="grid grid-cols-4 border-b border-gray-100">
                <div className="px-3 py-2 border-r border-gray-100">
                  <p className="text-[10px] uppercase tracking-widest text-gray-500 mb-0.5 font-medium">Requisition No.</p>
                  <p className="text-[13px] font-semibold text-gray-800">{props.productionRequisition.productionNo}</p>
                </div>
                <div className="px-3 py-2 border-r border-gray-100">
                  <p className="text-[10px] uppercase tracking-widest text-gray-500 mb-0.5 font-medium">Req. Date</p>
                  <p className="text-[13px] font-semibold text-gray-800">
                    {moment(props.productionRequisition.productionRequisitionReqDate).format("DD MMM YYYY")}
                  </p>
                </div>
                <div className="px-3 py-2 border-r border-gray-100">
                  <p className="text-[10px] uppercase tracking-widest text-gray-500 mb-0.5 font-medium">Batch No.</p>
                  <p className="text-[13px] font-semibold text-gray-800">{props.productionRequisition.batchNo}</p>
                </div>
                <div className="px-3 py-2">
                  <p className="text-[10px] uppercase tracking-widest text-gray-500 mb-0.5 font-medium">Batch Size</p>
                  <p className="text-[13px] font-semibold text-gray-800">{props.productionRequisition.batchSize}</p>
                </div>
              </div>

              <div className="grid grid-cols-4">
                <div className="px-3 py-2 border-r border-gray-100">
                  <p className="text-[10px] uppercase tracking-widest text-gray-500 mb-0.5 font-medium">MFG. Date</p>
                  <p className="text-[13px] font-semibold text-gray-800">
                    {moment(props.productionRequisition.mfgDate).format("MM/YYYY")}
                  </p>
                </div>
                <div className="px-3 py-2 border-r border-gray-100">
                  <p className="text-[10px] uppercase tracking-widest text-gray-500 mb-0.5 font-medium">Exp. Date</p>
                  <p className="text-[13px] font-semibold text-gray-800">
                    {moment(props.productionRequisition.expDate).format("MM/YYYY")}
                  </p>
                </div>
                <div className="col-span-2 px-3 py-2">
                  <p className="text-[10px] uppercase tracking-widest text-gray-500 mb-0.5 font-medium">Note</p>
                  <p className="text-[13px] text-gray-500">{props.productionRequisition.productNote || "—"}</p>
                </div>
              </div>
            </div>

            <div className="border border-gray-200 rounded overflow-hidden">
              <table className="w-full text-[11px] border-collapse">
                <thead>
                  <tr className="bg-gray-100 border-b border-gray-300">
                    <th className="text-left px-3 py-2 text-[11px] uppercase tracking-widest text-gray-600 font-bold w-[50%]">Material Name</th>
                    <th className="text-left px-3 py-2 text-[11px] uppercase tracking-widest text-gray-600 font-bold w-[16%]">Stage</th>
                    <th className="text-right px-3 py-2 text-[11px] uppercase tracking-widest text-gray-600 font-bold w-[18%]">Qty.</th>
                    <th className="text-right px-3 py-2 text-[11px] uppercase tracking-widest text-gray-600 font-bold w-[16%]">UOM</th>
                  </tr>
                </thead>
                <tbody>
                  {props.rmFormulaList && props.rmFormulaList.length > 0 ? (
                    props.rmFormulaList.map((item, key) => (
                      <tr key={key} className="border-b border-gray-100 last:border-b-0 bg-white">
                        <td className="text-[12px] leading-[1.6] px-3 py-1.5 font-medium text-gray-700">{item.rmName}</td>
                        <td className="px-3 py-1.5 text-gray-700 font-medium text-[12px] leading-[1.6] tracking-wide">{item.stageName}</td>
                        <td className="text-[12px] leading-[1.6] px-3 py-1.5 text-right font-semibold text-gray-700">{item.netQty}</td>
                        <td className="px-3 py-1.5 text-right text-gray-700 text-[12px] leading-[1.6] font-medium">{item.rmUOM ? item.rmUOM : item.uom}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={4} className="text-center py-6 text-gray-500 text-[14px]">No Records Found</td>
                    </tr>
                  )}
                </tbody>
              </table>

              <div className="flex justify-end border-t border-gray-200">
                <div className="flex">
                  <div className="px-5 py-2.5 bg-gray-50 border-l border-gray-200 min-w-[148px]">
                    <p className="text-[10px] uppercase tracking-widest text-gray-500 mb-1">Total Solid Weight</p>
                    <p className="text-[12px] font-bold text-gray-900">{props.solidWeight ? props.solidWeight : 0}</p>
                  </div>
                  <div className="px-5 py-2.5 bg-gray-50 border-l border-gray-200 min-w-[148px]">
                    <p className="text-[10px] uppercase tracking-widest text-gray-500 mb-1">Total Liquid Weight</p>
                    <p className="text-[12px] font-bold text-gray-900">{props.liquidWeight ? props.liquidWeight : 0}</p>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div className="h-6 print:hidden" />

          {/*---------- Print template ----------*/}
          <div className="page hidden" id="printableArea">

            <div className="print-content">
              <div className="print-header">
                <div className="print-header__cell">
                  <h1 className="print-header__company">{Companyname}</h1>
                  <p className="print-header__title">Production Requisition Slip</p>
                </div>
              </div>

              <div className="from-to">
                <div className="from-to__cell">
                  <p className="field-label">From</p>
                  <p className="field-value">Production DEPT.</p>
                </div>
                <div className="from-to__cell--arrow">→</div>
                <div className="from-to__cell from-to__cell--right">
                  <p className="field-label">To</p>
                  <p className="field-value">Store DEPT.</p>
                </div>
              </div>

              <div className="info-card">
                <div className="info-card__product-header">
                  <span className="info-card__product-label">Product Name :</span>
                  <span className="info-card__product-name">{props.productionRequisition.productName}</span>
                </div>

                <div className="info-card__row info-card__row--bordered">
                  <div className="info-card__col">
                    <p className="field-label">Requisition No.</p>
                    <p className="field-value">{props.productionRequisition.productionNo}</p>
                  </div>
                  <div className="info-card__col">
                    <p className="field-label">Req. Date</p>
                    <p className="field-value">{moment(props.productionRequisition.productionRequisitionReqDate).format("DD MMM YYYY")}</p>
                  </div>
                  <div className="info-card__col">
                    <p className="field-label">Batch No.</p>
                    <p className="field-value">{props.productionRequisition.batchNo}</p>
                  </div>
                  <div className="info-card__col info-card__col--no-border">
                    <p className="field-label">Batch Size</p>
                    <p className="field-value">{props.productionRequisition.batchSize}</p>
                  </div>
                </div>

                <div className="info-card__row">
                  <div className="info-card__col">
                    <p className="field-label">MFG. Date</p>
                    <p className="field-value">{moment(props.productionRequisition.mfgDate).format("MM/YYYY")}</p>
                  </div>
                  <div className="info-card__col">
                    <p className="field-label">Exp. Date</p>
                    <p className="field-value">{moment(props.productionRequisition.expDate).format("MM/YYYY")}</p>
                  </div>
                  <div className="info-card__col info-card__col--half">
                    <p className="field-label">Note</p>
                    <p className="field-value--muted">{props.productionRequisition.productNote || "—"}</p>
                  </div>
                </div>
              </div>

              {/* Materials Table */}
              <div className="materials-card">
                <table className="materials-table">
                  <thead>
                    <tr>
                      <th>Material Name</th>
                      <th>Stage</th>
                      <th>Qty.</th>
                      <th>UOM</th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.rmFormulaList && props.rmFormulaList.length > 0 ? (
                      props.rmFormulaList.map((item, key) => (
                        <tr key={key}>
                          <td>{item.rmName}</td>
                          <td>{item.stageName}</td>
                          <td>{item.netQty}</td>
                          <td>{item.rmUOM ? item.rmUOM : item.uom}</td>
                        </tr>
                      ))
                    ) : (
                      <tr className="no-records">
                        <td colSpan={4}>No Records Found</td>
                      </tr>
                    )}
                  </tbody>
                </table>

                <div className="materials-footer">
                  <div className="materials-footer__row">
                    <div className="materials-footer__spacer" />
                    <div className="materials-footer__cell">
                      <p className="materials-footer__label">Total Solid Weight</p>
                      <p className="materials-footer__value">{props.solidWeight || 0}</p>
                    </div>
                    <div className="materials-footer__cell">
                      <p className="materials-footer__label">Total Liquid Weight</p>
                      <p className="materials-footer__value">{props.liquidWeight || 0}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </ModalBasic>
    </>
  );
}